// 文件i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)  //会把$t挂到Vue.prototype上，以便在.vue文件中使用this.$t()

// 国际化
const i18n = new VueI18n({
    locale: 'zh-CN',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh-CN': require('./zh.json'),   // 中文语言包
        'en-US': require('./en.json'),   // 英文语言包
        'ja-Jp': require('./ja-Jp.json')    // 日语语言包
    }
})

export default i18n